import initialLayerState from "../layer.initialState";
import { reduxActions as LAYER} from "_constants/layer.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const one = {
  [LAYER.ONE_STARTED]: (state) => ({
    ...state,
    one: {
      ...state.one,
      status: LOADING
    }
  }),
  
  [LAYER.ONE_SUCCESS]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      data: payload?.data?.[0] ?? null,
      error: null,
      status: SUCCESS
    }
  }),
  
  [LAYER.ONE_FAIL]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [LAYER.ONE_RESET]: (state) => ({
    ...state,
    one: initialLayerState.one
  })
};

export default one;
